import { render, staticRenderFns } from "./Clientaccess.vue?vue&type=template&id=d2c802c6&"
import script from "./Clientaccess.vue?vue&type=script&lang=js&"
export * from "./Clientaccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports